import {
  Menu as MenuIcon,
  Notifications as NotificationsIcon,
} from "@mui/icons-material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
  AppBar,
  Avatar,
  Box,
  Button,
  IconButton,
  MenuItem,
  Modal,
  Select,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AuthContext } from "../../auth/AuthContext";
import Add from "../../Pages/Jobs/Add";
import {
  getUserDetails,
  updateUserDetails,
} from "../../Redux/auth/auth.action";
import { contactUsGetData } from "../../Redux/contactus/contact.action";
import { userRole } from "../../utils/constants";
import Notifications from "./Notifications";
import { toast } from "react-toastify";
const getRandomColor = () => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

const Navbar = ({ onOpen }) => {
  const { user } = useContext(AuthContext);
  const [openNotifications, setOpenNotifications] = useState(false);
  const [userModal, setUserModal] = useState(false);
  const dispatch = useDispatch();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [userDetails, setUserDetails] = useState();
  const [editable, setEditable] = useState(false);
  const { data } = useSelector((state) => state.contactusReducer);
  const { profile } = useSelector((state) => state.loginReducer);

  useEffect(() => {
    dispatch(getUserDetails());
    dispatch(contactUsGetData({ page: 1, limit: 10 }));
  }, [dispatch]);

  useEffect(() => {
    setUserDetails(profile);
  }, [profile, user]);

  const total = data?.data?.reduce(
    (acc, curr) => (!curr.isRead ? acc + 1 : acc),
    0
  );

  const handleCloseUserModal = () => {
    setUserModal(false);
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpenNotifications(open);
  };

  const toggleDrawer1 = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setIsDrawerOpen(open);
  };

  const getAvatarLatter = (name) => {
    return name
      .split(" ")
      .map((word) => word[0])
      .join("")
      .toUpperCase();
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
  };

  const handleSaveUserDetails = () => {
    dispatch(updateUserDetails(profile?._id, userDetails)).then(() =>
      dispatch(getUserDetails())
    );
    setEditable(false);
    toast.success("User Details updated successfully!");
  };

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          zIndex: 1100,
          background: "#191970",
          boxShadow: "none",
          width: "100%",
        }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open menu"
            onClick={onOpen}
            sx={{ display: { md: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          <Box sx={{ flexGrow: 1 }}>
            {/* <Avatar sx={{ width: 66, height: 66 }} src={img} /> */}
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Box
              onClick={toggleDrawer1(true)}
              sx={{
                cursor: "pointer",
              }}
            >
              <AddCircleOutlineIcon />
            </Box>
            <Box
              onClick={toggleDrawer(true)}
              sx={{
                display: "flex",
                cursor: "pointer",
                alignItems: "center",
                mr: 1,
              }}
            >
              <IconButton color="inherit">
                <NotificationsIcon />
              </IconButton>
              {total > 0 && (
                <Typography
                  variant="span"
                  component="div"
                  sx={{
                    height: "15px",
                    width: "15px",
                    fontSize: "10px",
                    textAlign: "center",
                    ml: -2,
                    mt: -3,
                    background: "red",
                    borderRadius: "50%",
                    padding: 0.5,
                    zIndex: 1,
                  }}
                >
                  {total >= 100 ? "99+" : total}
                </Typography>
              )}
            </Box>
            <Box
              sx={{
                cursor: "pointer",
              }}
              onClick={() => setUserModal(true)}
            >
              <Avatar />
            </Box>
          </Box>
        </Toolbar>
      </AppBar>

      <Modal open={userModal} onClose={handleCloseUserModal}>
        <Box
          sx={{
            position: "absolute",
            top: "8%",
            right: "2%",
            width: { xs: "90%", sm: "75%", md: "50%", lg: "30%" },
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
          }}
        >
          {/* Avatar Section */}
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <Avatar
              sx={{
                bgcolor: getRandomColor(),
                width: 100,
                height: 100,
                fontSize: 40,
              }}
              src={userDetails?.profile_pic}
            >
              {getAvatarLatter(userDetails?.name || "")}
            </Avatar>
          </Box>

          {/* User Information */}
          <Box>
            <TextField
              variant="outlined"
              fullWidth
              margin="normal"
              label="Name"
              value={userDetails?.name}
              onChange={(e) => {
                setUserDetails({ ...userDetails, name: e.target.value });
              }}
              InputProps={{
                readOnly: !editable,
              }}
            />
            <TextField
              variant="outlined"
              fullWidth
              margin="normal"
              label="Email"
              value={userDetails?.email}
              InputProps={{
                readOnly: !editable,
              }}
              disabled
            />
            <TextField
              variant="outlined"
              fullWidth
              margin="normal"
              label="mobile"
              value={userDetails?.mobile}
              InputProps={{
                readOnly: !editable,
              }}
              disabled
            />
            <Select
              disabled={profile?.role !== "admin" || !editable}
              variant="outlined"
              fullWidth
              value={userDetails?.role}
              onChange={(e) =>
                setUserDetails({ ...userDetails, role: e.target.value })
              }
            >
              {userRole?.map((role) => (
                <MenuItem key={role} value={role}>
                  {role}
                </MenuItem>
              ))}
            </Select>
            <TextField
              variant="outlined"
              fullWidth
              margin="normal"
              label="Username"
              value={userDetails?.username}
              InputProps={{
                readOnly: !editable,
              }}
            />
          </Box>

          {/* Edit Button */}
          <Box
            sx={{
              textAlign: "center",
            }}
          >
            {!editable ? (
              <Button
                variant="outlined"
                size="small"
                onClick={() => setEditable(!editable)}
                sx={{ textTransform: "none" }}
              >
                Edit
              </Button>
            ) : (
              <Button
                variant="outlined"
                size="small"
                onClick={handleSaveUserDetails}
                sx={{ textTransform: "none" }}
              >
                Save
              </Button>
            )}
          </Box>

          {/* Logout Button */}
          <Box sx={{ textAlign: "center", mt: 4 }}>
            <Button variant="contained" color="error" onClick={handleLogout}>
              Logout
            </Button>
          </Box>
        </Box>
      </Modal>

      <Notifications isOpen={openNotifications} toggleDrawer={toggleDrawer} />
      <Add
        isDrawerOpen={isDrawerOpen}
        toggleDrawer={toggleDrawer1}
        mb={"rem"}
      />
    </>
  );
};

export default Navbar;
